<template>
  <button class="flex justify-center w-full bg-yellow-500 rounded-xl py-2 px-4"
          :disabled="loading"
          @touchstart="toggleAnimation($event)"
          @touchend="toggleAnimation($event)"
          @mousedown="toggleAnimation($event)"
          @mouseup="toggleAnimation($event)">
    <LoadingSpinner v-if="loading"/>
    <slot></slot>
  </button>
</template>

<script>
import LoadingSpinner from "@/components/General/LoadingSpinner";
export default {
  name: "Button",
  components: {LoadingSpinner},
  data() {
    return {
      loading: this.$loading
    }
  },
  methods: {
    toggleAnimation(event) {
      if (!this.loading) {
        event.currentTarget.classList.toggle('bg-yellow-500')
        event.currentTarget.classList.toggle('bg-yellow-300')
      }
    }
  }
}
</script>

<style scoped>

</style>